import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { NAMES } from '@ifit/react-icons';
import classNames from 'classnames';
import { Navigation } from '../../navigation/react-redux-nav';

import { solidWhite } from '../../theme/colors';
import './summary-icon.css';

export default class SummaryIcon extends Component {
  static get propTypes() {
    return {
      pageTitle: PropTypes.string,
      pageIcon: PropTypes.string,
      pageName: PropTypes.string,
      isCompleted: PropTypes.bool,
      mediaType: PropTypes.string
    };
  }

  render() {
    return (
      <div className={ classNames('summary-icon-block', this.props.mediaType) }>
        <div className="icon-container">
          <Navigation.JumpTo page={ this.props.pageName }>
            <Icon
              className="summary-icon"
              name={ this.props.pageIcon }
              color={ solidWhite }
              size={ this.props.mediaType === 'phone' ? 16 : 22 }
              unitSize="px"
            />
          </Navigation.JumpTo>
          <div className={ classNames('summary-completion-badge', { 'badge-complete': this.props.isCompleted }) }>
            <Icon
              name={ NAMES.CHECKMARK }
              color={ solidWhite }
              size={ 8 }
              unitSize="px"
            />
          </div>
        </div>
        <p>{ this.props.pageTitle }</p>
      </div>
    );
  }
}
